export const NO_SAVED_OFFER = 'no_saved_offers'
